module.exports = __webpack_public_path__ + "static/RZD-a3e6e4a8a1b6631cf8f3a3a13c046dca.png";